// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TypeSensorParameterDO } from '../../../requests';

interface Props {
  formValues: {
    data: Partial<TypeSensorParameterDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Parameter</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="string"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Value</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.value || ''}
            name="value"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Bytes</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.bytes || '0'}
            name="bytes"
            onChange={props.onChange}
            min="0"
            pattern="[0-9]+"
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
    </fieldset>
  );
}
